import { render, staticRenderFns } from "./externalInstitutionManage.vue?vue&type=template&id=1a1bb727"
import script from "./externalInstitutionManage.vue?vue&type=script&lang=js"
export * from "./externalInstitutionManage.vue?vue&type=script&lang=js"
import style0 from "./externalInstitutionManage.vue?vue&type=style&index=0&id=1a1bb727&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports